/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { FarmTotal, FarmTotalFromJSON, FarmTotalFromJSONTyped, FarmTotalToJSON } from './FarmTotal'

/**
 *
 * @export
 * @interface Bonuses
 */
export interface Bonuses {
  /**
   *
   * @type {number}
   * @memberof Bonuses
   */
  cashback?: number
  /**
   *
   * @type {number}
   * @memberof Bonuses
   */
  referralFarming?: number
  /**
   *
   * @type {number}
   * @memberof Bonuses
   */
  teamFarming?: number
  /**
   *
   * @type {number}
   * @memberof Bonuses
   */
  referralTrading?: number
  /**
   *
   * @type {number}
   * @memberof Bonuses
   */
  teamTrading?: number
  /**
   *
   * @type {number}
   * @memberof Bonuses
   */
  staking?: number
  /**
   *
   * @type {number}
   * @memberof Bonuses
   */
  holderBonus?: number
  /**
   *
   * @type {Array<FarmTotal>}
   * @memberof Bonuses
   */
  farms?: Array<FarmTotal>
}

export function BonusesFromJSON(json: any): Bonuses {
  return BonusesFromJSONTyped(json, false)
}

export function BonusesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Bonuses {
  if (json === undefined || json === null) {
    return json
  }
  return {
    cashback: !exists(json, 'cashback') ? undefined : json['cashback'],
    referralFarming: !exists(json, 'referralFarming') ? undefined : json['referralFarming'],
    teamFarming: !exists(json, 'teamFarming') ? undefined : json['teamFarming'],
    referralTrading: !exists(json, 'referralTrading') ? undefined : json['referralTrading'],
    teamTrading: !exists(json, 'teamTrading') ? undefined : json['teamTrading'],
    staking: !exists(json, 'staking') ? undefined : json['staking'],
    holderBonus: !exists(json, 'holderBonus') ? undefined : json['holderBonus'],
    farms: !exists(json, 'farms') ? undefined : (json['farms'] as Array<any>).map(FarmTotalFromJSON),
  }
}

export function BonusesToJSON(value?: Bonuses | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    cashback: value.cashback,
    referralFarming: value.referralFarming,
    teamFarming: value.teamFarming,
    referralTrading: value.referralTrading,
    teamTrading: value.teamTrading,
    staking: value.staking,
    holderBonus: value.holderBonus,
    farms: value.farms === undefined ? undefined : (value.farms as Array<any>).map(FarmTotalToJSON),
  }
}
